export const BookingApiVersion = 'v4';
export const ContentVersion = 'v1';
